<template>
  <div>
    <p class="mb-6">{{ message }}</p>
    <div class="is-flex is-justify-content-space-evenly">
      <button @click="onClickYes" class="button is-info" style="width: 100px;">כן</button>
      <button @click="onClickNo" class="button is-danger" style="width: 100px;">לא</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalConfirmation',
  props: {
    message: {
      type: String
    },
    onConfirmation: {
      type: Function,
      default: () => {}
    },
    onReject: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    onClickYes () {
      this.onConfirmation(this.$attrs.payload.modal_id)
    },
    onClickNo () {
      this.onReject(this.$attrs.payload.modal_id)
    }
  }
}
</script>
